<div class="page">
  <nav class="breadcrumb" [attr.aria-label]="'COMMON.BREADCRUMB' | translate">
    <a [routerLink]="majorsLink" class="breadcrumb-link">{{ 'MAJORS.TITLE' | translate }}</a>
    <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
    <span class="breadcrumb-current">{{ major?.name || '...' }}</span>
  </nav>

  <div class="page-header">
    <div>
      <h1>{{ major?.name || ('MAJORS.DETAILS' | translate) }}</h1>
      <p class="page-subtitle" *ngIf="major">
        {{ 'MAJORS.GRADE_LEVEL' | translate }} · {{ majorClasses.length }} {{ 'MAJORS.CLASSES_COUNT' | translate }}
      </p>
    </div>
    <div class="page-actions" *ngIf="major">
      <button type="button" class="btn btn-secondary" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'COMMON.BACK' | translate }}
      </button>
      <button type="button" class="btn btn-primary" *appAccess="'majors:edit'" (click)="onEdit()">
        <mat-icon>edit</mat-icon>
        {{ 'COMMON.EDIT' | translate }}
      </button>
    </div>
  </div>

  <div class="alert alert-error" *ngIf="errorMessage">{{ errorMessage | translate }}</div>

  <div class="card detail-card" *ngIf="loading">
    <div class="empty-state">{{ 'MAJORS.LOADING_DETAILS' | translate }}</div>
  </div>

  <div class="major-profile" *ngIf="!loading && major">
    <div class="profile-sections">
      <section class="info-card card">
        <header class="section-header">
          <mat-icon>info</mat-icon>
          <h3>{{ 'MAJORS.OVERVIEW' | translate }}</h3>
        </header>
        <div class="info-rows">
          <div class="info-row">
            <span class="info-label">{{ 'COMMON.NAME' | translate }}</span>
            <span class="info-value">{{ major.name }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ 'MAJORS.TOTAL_CLASSES' | translate }}</span>
            <span class="info-value">{{ majorClasses.length }}</span>
          </div>
        </div>
      </section>

      <section class="info-card card classes-card">
        <header class="section-header">
          <mat-icon>class</mat-icon>
          <h3>{{ 'MAJORS.CLASSES' | translate }}</h3>
          <span class="section-count" *ngIf="majorClasses.length">{{ majorClasses.length }}</span>
        </header>

        <div class="alert alert-error" *ngIf="detailError">{{ detailError | translate }}</div>

        <form class="inline-form" *appAccess="'majors:add'" [formGroup]="classForm" (ngSubmit)="addClassToMajor()">
          <div class="form-field">
            <label for="className">{{ 'MAJORS.ADD_CLASS' | translate }}</label>
            <input
              id="className"
              type="text"
              formControlName="name"
              [placeholder]="'MAJORS.CLASS_NAME' | translate"
            />
          </div>
          <button type="submit" class="btn btn-primary btn-sm" [disabled]="addingClass || classForm.invalid">
            {{ 'COMMON.ADD' | translate }}
          </button>
        </form>

        <div *ngIf="loadingClasses" class="empty-assignment">{{ 'MAJORS.LOADING_CLASSES' | translate }}</div>

        <div class="chip-list" *ngIf="!loadingClasses && majorClasses.length">
          <span class="chip chip-class class-chip" *ngFor="let classItem of majorClasses">
            <span>{{ classItem.name }}</span>
            <button
              *appAccess="'majors:delete'"
              type="button"
              class="chip-remove"
              (click)="deleteClass(classItem)"
              [attr.aria-label]="('COMMON.DELETE' | translate) + ' ' + classItem.name"
            >
              <mat-icon>close</mat-icon>
            </button>
          </span>
        </div>

        <p *ngIf="!loadingClasses && !majorClasses.length" class="empty-assignment">
          {{ 'MAJORS.NO_CLASSES' | translate }}
        </p>
      </section>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="open">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ 'MAJORS.EDIT_TITLE' | translate }}</h3>
      <button type="button" class="btn btn-ghost btn-icon" (click)="closeEditModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="alert alert-error" *ngIf="editError">{{ editError | translate }}</div>
      <form [formGroup]="editForm" (ngSubmit)="submitEdit()">
        <div class="form-field">
          <label for="majorName">{{ 'COMMON.NAME' | translate }}</label>
          <input id="majorName" type="text" formControlName="name" />
          <span class="error" *ngIf="editForm.get('name')?.touched && editForm.get('name')?.hasError('required')">
            {{ 'COMMON.NAME_REQUIRED' | translate }}
          </span>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeEditModal()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="btn btn-primary" (click)="submitEdit()">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </div>
  </div>
</div>
